module.exports = __webpack_public_path__ + "img/p-one-step-22.8681163d.png";